<template>
  <div>
    <!-- Título -->
    <div>
      <h4 class="title">Filtros</h4>
    </div>

    <div class="filtros-container">
      <!-- Filtro de año y mes -->
      <div class="subfiltro-container" :class="selectorDeFechasActivo == 'yearAndMonth' ? 'filtro-highlighted' : ''"
        @click="selectorDeFechasActivo = 'yearAndMonth'"
      >
        <YearAndMonthInput
          yearLabel="Año"
          monthLabel="Mes"
          :years="yearOptions"
          :months="monthOptions"
          v-model="yearAndMonth"
        />
      </div>

      <!-- Filtro de selección múltiple de fechas -->
      <div class="subfiltro-container" :class="selectorDeFechasActivo == 'rangeDate' ? 'filtro-highlighted' : ''"
        @click="selectorDeFechasActivo = 'rangeDate'"
      >
        <span class="filtro-title">Seleccionar fechas</span>
        <date-picker
          lang="es"
          v-model="rangeDate"
          :default-value="rangeDate"
          range
          class="w-auto"
          type="date"
          format="YYYY-MM-DD"
          valueType="format"
          :placeholder="'Seleccione un rango'"
          :disabled-date="disabledRange"
          :clearable="false"
        />
      </div>

      <!-- Filtro de canal -->
      <div class="subfiltro-container">
        <span class="filtro-title">Canal</span>
        <b-form-select
            :options="canalesOptions"
            v-model="idCanal"
        ></b-form-select>
      </div>

      <!-- Botón de submit -->
      <div class="button-container subfiltro-container">
        <b-btn variant="primary" @click="handleBuscarClick" :disabled="!estaHabilitaoBotonBusqueda">
          <i class="fas fa-search"></i>
          Buscar
        </b-btn>
      </div>

      <!-- Botón Descargar -->
      <div style="display: flex; align-items: flex-end; margin-bottom: 10px;">
        <button :disabled="!estaHabilitaoBotonBusqueda"  type="button" class="btn btn-sm btn-primary btn-circle" @click="handleDownloadClick">
            <i class="fas fa-download"></i>
        </button>
        <button :disabled="!estaHabilitaoBotonBusqueda" class="btn btn-sm btn-link" style="color: #00184D;" @click="handleDownloadClick">
          <b-spinner v-if="loading" small label="Loading..."></b-spinner> Descargar
        </button>

      </div>
      <div v-if="error">
        Error al realizar la descarga, intente nuevamente.
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import YearAndMonthInput from "./inputs/YearAndMonthInput.vue";

export default {
  components: { YearAndMonthInput },
  props: {
    months: Object,
    years: Array,
    canales: Array,
    error: Boolean,
    loading: Boolean,
  },
  data() {
    return {
      selectorDeFechasActivo: 'yearAndMonth',
      yearAndMonth: { year: null, month: null },
      rangeDate: [],
      today: new Date(),
      idCanal: null,
    };
  },
  computed: {
    /**
     * Función que retorna true si el botón de búsqueda está habilitado
     */
    estaHabilitaoBotonBusqueda() {
      const estaLLenoSelectorYearAndMonth = !!this.yearAndMonth.year
      const estaLlenoSelectorDeFechas = this.rangeDate.length == 2
      return (this.selectorDeFechasActivo == 'yearAndMonth' && estaLLenoSelectorYearAndMonth) || (this.selectorDeFechasActivo == 'rangeDate' && estaLlenoSelectorDeFechas)
    },
    /**
     * Array de opciones de años
     */
    yearOptions() {
      return this.years
    },
    monthOptions() {
      const options = [{ value: null, text: 'Todos' }]
      for (const value in this.months) {
        if (Object.hasOwnProperty.call(this.months, value)) {
          const text = this.months[value];
          options.push({ value, text })
        }
      }
      return options
    },
    canalesOptions() {
      const options =  this.canales?.map(canal => ({ value: canal.id, text: canal.nombre }))

      return [
        { value: null, text: 'Todos' },
        ...options
      ]
    },
    filtros() {
      let rangeDate = []
      if(this.selectorDeFechasActivo == 'rangeDate') {
        rangeDate = [...this.rangeDate]
      }

      if(this.selectorDeFechasActivo == 'yearAndMonth') {
        if(this.yearAndMonth.year  && this.yearAndMonth.month) {
          const year = this.yearAndMonth.year
          const month = this.yearAndMonth.month
          const firstDay = moment(`${year}-${month}-01`, 'YYYY-MM-DD').format('YYYY-MM-DD')
          const lastDay = moment(`${year}-${month}-01`, 'YYYY-MM-DD').endOf('month').format('YYYY-MM-DD')
          rangeDate = [firstDay, lastDay]
        } else if(this.yearAndMonth.year) {
          const year = this.yearAndMonth.year
          const firstDay = moment(`${year}-01-01`, 'YYYY-MM-DD').format('YYYY-MM-DD')
          const lastDay = moment(`${year}-12-31`, 'YYYY-MM-DD').format('YYYY-MM-DD')
          rangeDate = [firstDay, lastDay]
        }
      }

      const [startDate, endDate] = rangeDate
      return {startDate, endDate, canal: this.idCanal}
    }
  },
  methods: {
    /**
     * Función que se ejecuta al hacer click en el botón de descargar,
     * emite un evento @downloadClick
     */
    handleDownloadClick() {
      this.$emit('downloadClick')
    },
    /**
     * Función que se ejecuta al hacer click en el botón de buscar,
     * emite un evento @search con los datos de búsqueda
     * startDate, endDate, canal
     */
    handleBuscarClick() {    
      this.$emit("search", this.filtros);
    },
    /**
     * Función que define si una fecha etá deshabilitada para selección
     */
    disabledRange: function (date) {
      return date > this.today;
    },
  },
  watch: {
    filtros(val) {
      this.$emit('filtrosCambiaron', val)
    },
    /**
     * Cuando cambia el rango de fechas, se cambia el selector de fechas activo a rangeDate
     */
    rangeDate(val) {
      this.selectorDeFechasActivo = 'rangeDate'
    },
    /**
     * Cuando cambia el año o el mes, se cambia el selector de fechas activo a yearAndMonth
     */
    yearAndMonth(val) {
      this.selectorDeFechasActivo = 'yearAndMonth'
    },
  },
};
</script>

<style lang="scss" scoped>
.filtros-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.filtro-title {
  font-weight: bold;
  display: block;
  margin-bottom: 5px;
  width: 100%;
}

.filtros-date--selected {
  border-bottom: 2px solid rgba(70, 181, 255, 0.2);
  background: rgba(70, 181, 255, 0.1);
}

.title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 20px;
  text-transform: uppercase;
}

.nav-tabs {
  background-color: white;
  border: thin solidn #ddd;
}

.nav-tabs .nav-link.active {
  color: rgba(70, 181, 255, 1);
  background-color: rgba(70, 181, 255, 0.1);
}

.button-container {
  display: flex;
  align-items: flex-end;
}

.subfiltro-container {
  padding: 10px;
  transition: all .5s ease-out;
}

.filtro-highlighted {
  border-radius: 5px;
  background-image: linear-gradient(135deg, #fff 0%, rgba(70, 181, 255, .2) 30%, #fff 100%);

}
</style>
